import { Controller } from '@hotwired/stimulus';
const ramseyPlusDepartment = 'Ramsey+ Support';

export default class HelpCenterChatWidgetController extends Controller {
  static values = {
    name: String,
    email: String
  };

  static zendeskBaseSettings = {
    position: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    chat: {
      departments: {
        enabled: [],
        select: ramseyPlusDepartment
      },
      suppress: false
    }
  };

  static departmentSettings = {
    chatEnabled: {
      chat: {
        departments: {
          enabled: [],
          select: ramseyPlusDepartment
        },
        suppress: false
      }
    },
    chatDisabled: {
      chat: {
        suppress: true
      },
      helpCenter: {
        suppress: false
      }
    }
  };

  connect() {
    const { zE } = window;
    if (!zE) {
      return;
    }

    const {
      nameValue,
      emailValue,
      identifyUser,
      setDepartment,
      updateSettings
    } = this;
    const { zendeskBaseSettings } = HelpCenterChatWidgetController;

    identifyUser(nameValue, emailValue);

    // Set styling for the widget
    updateSettings(zendeskBaseSettings);

    const onDepartmentChange = setDepartment.bind(this);
    zE('webWidget:on', 'chat:departmentStatus', onDepartmentChange);
  }

  updateSettings(webWidgetSettings) {
    const { zE } = window;

    const settings = {
      webWidget: {
        ...webWidgetSettings
      }
    };

    zE('webWidget', 'updateSettings', settings);
  }

  identifyUser(name, email) {
    const { zE } = window;
    // prefill any user information we have
    zE('webWidget', 'identify', {
      name,
      email
    });
  }

  setDepartment(dept) {
    if (dept.name !== ramseyPlusDepartment) {
      return;
    }

    const { updateSettings } = this;
    const { departmentSettings } = HelpCenterChatWidgetController;
    const isOnline = dept.status === 'online';

    // eslint-disable-next-line no-console
    console.info(`${dept.name} is ${dept.status}`); // optional logging

    if (isOnline) {
      updateSettings(departmentSettings.chatEnabled);
      return;
    }

    updateSettings(departmentSettings.chatDisabled);
  }
}
